module.exports = __webpack_public_path__ + "static/img/mushroom1.f693e862.jpg";